import React from 'react'
import { Table } from '@UILibrary/Table'

interface FeedbackItem {
  feedback?: string
  comment?: string
  text?: string
  message?: string
  rating?: number
  area?: string
  category?: string
  type?: string
}

interface FeedbackTableProps {
  data: FeedbackItem[]
  showAreaColumn?: boolean
}

export const FeedbackTable: React.FC<FeedbackTableProps> = ({ data, showAreaColumn = false }) => {
  const columns = [
    {
      key: 'feedback',
      label: 'Feedback',
      render: (item: FeedbackItem) => item.feedback || item.comment || item.text || item.message
    },
    {
      key: 'rating',
      label: 'Rating',
      render: (item: FeedbackItem) => item.rating ? `${item.rating}/5` : '-'
    }
  ]

  if (showAreaColumn) {
    columns.push({
      key: 'area',
      label: 'Area',
      render: (item: FeedbackItem) => item.area || item.category || item.type || '-'
    })
  }

  return (
    <Table
      data={data}
      columns={columns}
      itemsPerPage={10}
    />
  )
}
